import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideRestore = ({ width = 16, height = 16, color = '#1F1F1F' }) =>
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M10.71 9.29L14 12.59V10H16V16H10V14H12.59L9.29 10.71L10.71 9.29ZM6 0V2H3.41L6.71 5.29L5.29 6.71L2 3.41V6H0V0H6Z' fill={color} />
    </svg>;

IconPowertrainGuideRestore.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideRestore;
